import { useEffect } from "react";
import { useNavigate, useRouterState } from "@tanstack/react-router";
import { useAuth } from "@/hooks/useAuth";
import { useMfaStatus } from "@/hooks/useMfa";

/**
 * Gate global que redirige a usuarios con rol admin/organizer hacia el flujo MFA
 * cuando aún no completaron la verificación AAL2.
 *
 * - Sin factor TOTP verificado → /auth/mfa-setup
 * - Con factor pero AAL1 → /auth/mfa-verify
 *
 * Las rutas /auth/mfa-setup, /auth/mfa-verify, /login y públicas no se redirigen.
 */
const EXEMPT_PREFIXES = [
  "/auth/mfa-setup",
  "/auth/mfa-verify",
  "/login",
  "/cookies",
  "/privacy",
  "/terms",
  "/unsubscribe",
];

export function MfaGate() {
  const navigate = useNavigate();
  const { user, loading: authLoading } = useAuth();
  const { loading, requiresMfa, hasEnrolledFactor, currentLevel, nextLevel } = useMfaStatus();
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    if (authLoading || loading || !user) return;
    if (!requiresMfa) return;
    if (EXEMPT_PREFIXES.some((p) => pathname.startsWith(p))) return;

    if (!hasEnrolledFactor) {
      navigate({ to: "/auth/mfa-setup", replace: true });
      return;
    }
    // tiene factor verificado pero está en AAL1 → debe challengear
    if (currentLevel === "aal1" && nextLevel === "aal2") {
      navigate({ to: "/auth/mfa-verify", replace: true });
    }
  }, [
    authLoading,
    loading,
    user,
    requiresMfa,
    hasEnrolledFactor,
    currentLevel,
    nextLevel,
    pathname,
    navigate,
  ]);

  return null;
}
